<template>
  <div class="studio-tile" :style="{ 'border-color': studio.color }">
    <div class="studio-tile__details">
      <h3 class="studio-tile__title">
        <router-link class="studio-tile__name" :to="{name: 'studio', params: {id: studio._id}}">
          {{studio.name}}
          <span>{{ studio.scenes.length }} Scenes</span>
        </router-link>
      </h3>
      <a class="studio-tile__website" v-if="studio.website" :href="studio.website">
        {{studio.website.replace(/\/$/, '').replace('http://','').replace('https://','')}}
      </a>
    </div>
    <div class="studio-tile__scenes">
      <div v-for="(scene, index) in studio.scenes" class="image-container" v-if="index < 4 && scene.thumbnail">
        <img class="image-container__image" :data-index="index" :src="imageUrlFor(scene.thumbnail).ignoreImageParams().width(480)"/>
      </div>
    </div>
  </div>
</template>

<script>
import sanity from "../sanity";
import imageUrlBuilder from "@sanity/image-url";
const imageBuilder = imageUrlBuilder(sanity);

export default {
  name: 'StudioTile',
  props: {
    studio: Object,
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    imageUrlFor(source) {
      return imageBuilder.image(source);
    }
  }
};
</script>

<style scoped>
.studio-tile {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
  padding: 24px;
  height: 100%;
  min-height: 200px;
  border-width: 1px;
  border-style: solid;
}
.studio-tile__title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: space-between;
  width: 100%;
  margin: 0;
  height: 100%;
}
.studio-tile__details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 50%;
  margin: 0;
  height: 100%;
}
.studio-tile__scenes {
  display: grid;
  margin: 0;
  padding: 0;
  grid-gap: 12px;
  grid-template-columns: 1fr 1fr;
  width: 50%;
  margin: 0;
  height: calc(100% + 12px);
  padding-bottom: 12px;
}
.studio-tile__name span {
    display: block;
    font-size: 0.875rem;
    font-weight: 400;
    margin-top: 6px;
    padding-right: 12px;
}
.studio-tile__name {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-mono-0);
  text-decoration: none;
  width: 100%;
    height: 100%;
    display: block;
}
.studio-tile__website {
  font-size: 12px;
  white-space: nowrap;
  font-weight: 500;
  color: var(--color-mono-0);
  text-decoration: none;
}
.image-container {
  pointer-events: none;
}
.image-container__image {
  pointer-events: none;
  position: relative;
  width: 100%;
}
</style>
